<template>
  <v-card flat class="rounded-lg details-wrapper">
    <v-card-title class="profile-card-title">اطلاعات کاربری</v-card-title>
    <v-divider class="mx-4 my-0"/>

    <v-card-text class="pa-2">
      <v-row no-gutters>
        <v-col cols="12" md="6" class="pa-2">
          <label for="name">نام *</label>
          <v-text-field id="name" outlined placeholder="name" append-icon="mdi-account" dense/>
        </v-col>

        <v-col cols="12" md="6" class="pa-2">
          <label for="name">نام خانوادگی *</label>
          <v-text-field id="name" outlined placeholder="family" append-icon="mdi-account-supervisor" dense/>
        </v-col>

        <v-col cols="12" md="6" class="pa-2">
          <label for="name">تاریخ تولد</label>
          <custom-date-picker outlined dense placeholder="1379/07/04" append-icon="mdi-calendar-month"
                              format="date" :max="max" sp="/"/>
        </v-col>

        <v-col cols="12" md="6" class="pa-2">
          <label for="sex">جنسیت</label>
          <div class="d-flex">
            <v-btn-toggle mandatory dense group color="primary" class="justify-space-between w-100" id="sex">
              <v-btn min-width="calc(50% - 12px)" class="rounded" value="female">
                <v-icon class="me-3">mdi-face-woman</v-icon>
                خانم
              </v-btn>

              <v-btn min-width="calc(50% - 12px)" class="rounded" value="male">
                <v-icon class="me-3">mdi-face-man</v-icon>
                آقا
              </v-btn>
            </v-btn-toggle>
          </div>
        </v-col>

        <v-col cols="12" sm="6" class="pa-2">
          <label for="fixedNumber">شماره ثابت</label>
          <v-text-field type="number" id="fixedNumber" outlined placeholder="0311234567"
                        append-icon="mdi-phone-classic" dense/>
        </v-col>

        <v-col cols="12" sm="6" class="pa-2">
          <label for="email">ایمیل</label>
          <v-text-field id="email" outlined placeholder="example@any.any" append-icon="mdi-at" dense/>
        </v-col>

        <v-col cols="12" sm="6" class="pa-2">
          <label for="phone">شماره تماس</label>
          <v-text-field value="09123456789" id="phone" outlined append-icon="mdi-phone" dense readonly/>
        </v-col>

        <v-col cols="12" sm="6" class="pa-2">
          <label for="nationalCode">کد ملی</label>
          <v-text-field id="nationalCode" outlined placeholder="12345678912"
                        append-icon="mdi-card-account-details" dense/>
        </v-col>
      </v-row>
    </v-card-text>

    <v-card-actions class="justify-end pa-4">
      <v-btn color="primary" large class="rounded-lg" depressed width="120">
        <v-icon class="me-2">mdi-check</v-icon>
        ثبت تغییرات
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import CustomDatePicker from "../../../content/custom-date-picker";

export default {
  name: "userInfo",

  components: {CustomDatePicker},

  data: () => ({
    max: '',
  }),

  mounted() {
    this.max = this.nowDateTimeString('/')
  }
}
</script>

<style scoped lang="scss">
.profile-card-title {
  position: relative;

  &:before {
    content: '';
    position: absolute;
    right: 6px;
    top: 50%;
    transform: translateY(-50%);
    width: 3px;
    height: 24px;
    background: dodgerblue;
    border-radius: 8px;
  }
}
</style>